import React from "react";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Field, reduxForm, SubmissionError, reset} from 'redux-form'
import {connect} from "react-redux";
import _ from 'lodash'
import Paper from "@material-ui/core/Paper";
import Copyright from "../../components/Copyright";
import {changePassword} from "../../actions/session";
import styles from "./ChangePasswordStyles";

import {theme} from '../Dashboard/theme';

let themeCustom = {
  ...theme,
};

const renderFromHelper = (touched, error) => !(touched && error) ? null : touched && error;

const validate = values => {
  const errors = {};
  if (!values.currentPassword) {
    errors['currentPassword'] = 'Required'
  }
  if (!values.newPassword) {
    errors['newPassword'] = 'Required'
  }
  if (!values.confirmPassword) {
    errors['confirmPassword'] = 'Required'
  } else if (values.confirmPassword !== values.newPassword) {
    errors["confirmPassword"] = "Passwords must match";
  }
  return errors
};

class ChangePassword extends React.Component {

  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '16px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={renderFromHelper(touched, error, this.props)}
      variant="outlined"
      margine="normal"
      fullWidth
      {...input}
      {...custom}
    />
  );

  onSubmit = (formValues) => {
    return this.props.changePassword(this.props.user.userId, formValues.currentPassword, formValues.newPassword).then(() => {
      const {errors, message} = this.props.error;
      if (!_.isEmpty(errors)) {
        errors.forEach(error => {
          const myKeys = Object.keys(error);
          const key = myKeys[0];
          const value = error[key];
          if (key === 'currentPassword') {
            throw new SubmissionError({currentPassword: value, _error: message})
          }
          if (key === 'newPassword') {
            throw new SubmissionError({newPassword: value, _error: message})
          }
          if (key === 'confirmPassword') {
            throw new SubmissionError({confirmPassword: value, _error: message})
          }
        });
      }
    });
  };

  render() {
    const {classes, handleSubmit} = this.props;
    return (
      <ThemeProvider theme={themeCustom}>
        <Container component="main" maxWidth="xs" style={{
          minHeight: "100%vh",
          minWidth: "100%vw",
          display: "flex",
          flexDirection: "column"
        }}>
          <CssBaseline/>
          <div className={classes.paper} style={{flex: "1 0 auto"}}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
              Change Password
            </Typography>
            <Grid>
              <Paper>
                <Container>
                  <form
                    className={classes.form} onSubmit={handleSubmit(this.onSubmit)}>
                    <Field
                      name="currentPassword"
                      label="Current Password"
                      type="password"
                      component={this.renderTextField}
                    />
                    <Field
                      name="newPassword"
                      label="New Password"
                      type="password"
                      component={this.renderTextField}
                    />
                    <Field
                      name="confirmPassword"
                      label="Confirm Password"
                      type="password"
                      component={this.renderTextField}
                    />
                    <Grid container justify="center">
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </form>
                </Container>
              </Paper>
            </Grid>
          </div>
          <Copyright textColor={theme.palette.primary.light}/>
        </Container>
      </ThemeProvider>
    );
  };
}

const afterSubmit = (result, dispatch) =>
  dispatch(reset('ChangePasswordForm'));

const mapStateToProps = (state) => {
  return ({
    user: state.session,
    error: state.error
  });
};
//
const mapDispatchToProps = dispatch => ({
  changePassword: (userId, currentPassword, newPassword) => dispatch(changePassword(userId, currentPassword, newPassword))
});

ChangePassword = withStyles(styles, {withTheme: true})(ChangePassword);

ChangePassword = connect(
  mapStateToProps,
  mapDispatchToProps)(ChangePassword);

ChangePassword = reduxForm({
  form: 'ChangePasswordForm',
  validate,
  onSubmitSuccess: afterSubmit
})(ChangePassword);

export default ChangePassword;